import { Box, Typography } from '@mui/material';
import React from 'react';
import { T } from '../../theme/tokens';

export interface GradeBarProps {
  label: string;
  value: number;
  max?: number;
}

const GradeBar: React.FC<GradeBarProps> = ({ label, value, max = 10 }) => {
  const pct = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <Typography sx={{ fontSize: 11, color: T.textSubtle }}>{label}</Typography>
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: T.textMuted, fontVariantNumeric: 'tabular-nums' }}>
          {value}/{max}
        </Typography>
      </Box>
      <Box sx={{ height: 4, bgcolor: T.borderSoft, borderRadius: '2px', overflow: 'hidden' }}>
        <Box sx={{ height: '100%', width: `${pct}%`, bgcolor: T.tierTop, borderRadius: '2px', transition: 'width 200ms ease' }} />
      </Box>
    </Box>
  );
};

export default GradeBar;
